import { useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const CtaJoinSection = () => {
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const saveEmail = async () => {
    if (!email) return;

    setLoader(true);
    setMessage("");

    try {
      // Check for duplicate
      const q = query(
        collection(db, "waitlist"),
        where("email", "==", email.toLowerCase())
      );
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setMessage("This email is already on the waitlist.");
        return;
      }

      // Add new email
      await addDoc(collection(db, "waitlist"), {
        email: email.toLowerCase(),
        createdAt: serverTimestamp(),
      });

      setMessage("Email submitted successfully!");
      setTimeout(() => setMessage(""), 3000);
      setEmail("");
    } catch (error) {
      console.error("Error saving email:", error);
      setMessage("Something went wrong. Please try again.");
      setTimeout(() => setMessage(""), 3000);
    } finally {
      setLoader(false);
    }
  };

  return (
    <section id="ctaSection" className="bg-white p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="rounded-3xl text-white text-center py-12 px-6 sm:py-16 sm:px-8 bg-[radial-gradient(circle_at_50%_0%,theme(colors.sky.300),theme(colors.blue.500))]">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
            Join The Founding 500 Members
          </h2>
          <p className="mt-4 text-lg text-white/80 max-w-2xl mx-auto">
            Enter your email now to join the Founding 500 - No spam. Just
            lifetime perks, powerful tools, and one very smart business move.
            Let's Get Started.
          </p>

          <form
            className="mt-8 max-w-lg mx-auto flex flex-col sm:flex-row sm:gap-4"
            onSubmit={(e) => {
              e.preventDefault();
              saveEmail();
            }}
          >
            <label htmlFor="email-address" className="sr-only">
              Email address
            </label>
            <input
              id="email-address"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full sm:flex-1 appearance-none bg-[#E9E9E9] rounded-xl border-0 px-5 py-3 text-black placeholder:text-gray shadow-sm focus:outline-none focus:ring-2 focus:ring-white"
              placeholder="Enter your email"
              required
            />
            <button
              type="submit"
              className="w-full sm:w-auto mt-4 sm:mt-0 bg-white text-gray-700 rounded-xl px-8 py-3 font-semibold shadow-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-500 focus:ring-white transition-colors"
            >
              {loader ? (
                <div className="text-dark flex justify-center items-center">
                  <div className="w-5 h-5 border-2 border-gray-800 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                <>Join the waitlist</>
              )}
            </button>
          </form>

          {message && (
            <p className="mt-4 text-sm text-white">{message}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default CtaJoinSection;
